import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export interface MuiAutocompleteProps {
  defaultProps?: ComponentsProps['MuiAutocomplete'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiAutocomplete'];
  variants?: ComponentsVariants['MuiAutocomplete'];
}

const MuiAutocomplete: MuiAutocompleteProps = {
  styleOverrides: {
    root: {
      width: '100%',
    },
    paper: ({ theme }) => ({
      '& .MuiAutocomplete-listbox': {
        padding: '0',
        '.MuiAutocomplete-option': {
          color: theme.palette.primary.contrastText,
          padding: '10px 17px',
          alignItems: 'center',
          fontSize: 16,
          fontWeight: 400,
          [theme.breakpoints.down('xl')]: {
            padding: '7px 13px',
            fontSize: 12,
            lineHeight: '14px',
          },
        },
        '.MuiAutocomplete-option[aria-selected="true"]': {
          backgroundColor: 'rgba(46, 204, 113, 0.1)',
          color: theme.palette.primary.light,
        },
        /* eslint-disable max-len */
        '.MuiAutocomplete-option[aria-selected="true"].Mui-focused, .MuiAutocomplete-option.Mui-focused':
          {
            backgroundColor: 'rgba(46, 204, 113, 0.1)',
          },
      },
    }),
    endAdornment: {
      top: 'auto',
      '& .MuiAutocomplete-popupIndicator': {
        transition: '0.3s',
      },
    },
  },
};

export default MuiAutocomplete;
